import { GroupName, LocaleType } from './types';

export const translateGroupName = (
  label: GroupName | null | string,
  locale: string
) => {
  if (typeof label === 'string') return label;

  return label ? label[locale as LocaleType] : '';
};
